<template>
  <ValidationObserver ref="observer" v-slot="{ handleSubmit }">
    <section>
      <p class="mb-3">
        <!-- eslint-disable vue/no-v-html -->
        <span v-html="$t('registerPage.informations-personnelles-indications')"></span>
        <!-- eslint-enable vue/no-v-html -->
        <router-link :to="{ path: '/login' }">
          {{ $t("login") }}
        </router-link>
      </p>

      <InputWithValidation
        v-model="innerUtilisateur.nom"
        rules="required"
        :label="$t('registerPage.nom')"
        :placeholder="$t('registerPage.saisir-nom')"
        group="1"
      />

      <InputWithValidation
        v-model="innerUtilisateur.prenom"
        rules="required"
        :label="$t('registerPage.prenom')"
        :placeholder="$t('registerPage.saisir-prenom')"
        group="2"
      />

      <InputWithValidation
        v-model="innerUtilisateur.telephone"
        rules="required|validPhoneNumber"
        type="tel"
        :label="$t('registerPage.telephone')"
        :placeholder="$t('registerPage.saisir-telephone')"
        :input-notice="$t('registerPage.tooltip-telephone')"
        group="4"
      />

      <InputWithValidation
        v-model="innerUtilisateur.courriel"
        rules="required|email"
        type="email"
        :label="$t('registerPage.courriel')"
        :placeholder="$t('registerPage.saisir-courriel')"
        :input-notice="$t('registerPage.tooltip-courriel')"
        group="3"
      />

      <PasswordCreationWithValidation
        v-model="innerUtilisateur.motDePasse"
        :label="$t('input-password')"
        :placeholder="$t('input-password-example')"
      />

      <InputWithValidation
        v-model="innerUtilisateur.confirmationMotDePasse"
        rules="required|confirmed:password"
        type="password"
        password-reveal
        :placeholder="$t('input-password-example')"
        :label="$t('profilePage.mot-de-passe-confirmation')"
        :input-notice="$t('registerPage.tooltip-confirmation-mot-passe')"
      />

      <CheckboxWithValidation v-model="acceptRGPD" rules="accept-rgpd" vid="acceptRGPD">
        {{ $t("registerPage.accept-rgpd") }}
        <PDFLinkWithModal
          file-name="mentions-legales-sagae"
          :link-text="$t('registerPage.see-rgpd-link')"
          :num-pages="3"
        />
      </CheckboxWithValidation>
      <CheckboxWithValidation
        v-model="acceptNameVisibilityOnProtectedListing"
        vid="acceptNameVisibilityOnMap"
      >
        {{ $t("registerPage.accept-name-visibility-on-map") }}
      </CheckboxWithValidation>
    </section>

    <div class="buttons">
      <b-button type="is-primary" @click="handleSubmit(submit)">
        {{ $t("registerPage.suivant") }}
      </b-button>
    </div>
  </ValidationObserver>
</template>

<script lang="ts">
import { defineComponent, PropType } from "vue"
import ValidationObserver from "@/services/validation/ValidationObserver.vue"
import InputWithValidation from "@/views/inputs/InputWithValidation.vue"
import PasswordCreationWithValidation from "@/views/inputs/PasswordCreationWithValidation.vue"
import { UtilisateurRegistrationDTO } from "@/model/bean/GeneratedDTOs"
import CheckboxWithValidation from "@/views/inputs/CheckBoxWithValidation.vue"
import PDFLinkWithModal from "@/views/commons/PDFLinkWithModal.vue"
import { BButton } from "buefy"

export default defineComponent({
  name: "UserInformationsView",
  components: {
    ValidationObserver,
    InputWithValidation,
    PasswordCreationWithValidation,
    CheckboxWithValidation,
    PDFLinkWithModal,
    BButton,
  },
  props: {
    modelValue: {
      type: Object as PropType<UtilisateurRegistrationDTO>,
      default: null,
    },
  },

  emits: ["accept-visibility", "update:modelValue"],
  data() {
    return {
      innerUtilisateur: { ...this.modelValue } as UtilisateurRegistrationDTO,
      acceptRGPD: false,
      acceptNameVisibilityOnProtectedListing: false,
    }
  },
  watch: {
    acceptNameVisibilityOnProtectedListing(): void {
      this.$emit("accept-visibility", this.acceptNameVisibilityOnProtectedListing)
    },
    modelValue(): void {
      if (this.modelValue) {
        this.innerUtilisateur = this.modelValue
      }
    },
  },
  methods: {
    submit(): void {
      this.$emit("update:modelValue", this.innerUtilisateur)
    },
  },
})
</script>
<style scoped lang="scss">
:deep(.b-checkbox.checkbox:not(.button)) {
  margin-top: 1rem;
}

.buttons {
  justify-content: flex-end;
}
</style>
